




<div class="box">
  <div class="box-header app-secondary-nav">
    <nav mat-tab-nav-bar mat-align-tabs="center" class="app-secondary-nav__tabs">
      @for (link of navLinks; track link) {
        <a mat-tab-link
          [routerLink]="link?link.path:''"
          routerLinkActive #rla="routerLinkActive"
          [active]="rla.isActive">
          {{ link ? (link.label | translate) :''}}
        </a>
      }
    </nav>
  </div>
  <div class="box-body">

    <!-- <nav mat-tab-nav-bar [backgroundColor]="background" mat-align-tabs="center">
    <a mat-tab-link *ngFor="let link of navLinks"
      [routerLink]="link.path"
      (click)="activateLink(link)"
    [active]="activeLink.path == link.path"> {{ link.label }} </a>

  </nav> -->




  <router-outlet></router-outlet>

</div>
</div>
